export default __webpack_public_path__ + "static/media/preloader.f272c64a.gif";